import React from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'

class CartButton extends React.Component {

    render() {
        return (
            <ul className="cart-info">
                <li style={{paddingTop: '15px'}}>
                    <span className="btn cart-button" onClick={this.props.onClick}>
                        <FontAwesomeIcon icon={faShoppingCart} />
                    </span>
                    <span>({this.props.quantity})</span>
                </li>
            </ul>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quantity: state.quantity
    }
}

export default connect(mapStateToProps)(CartButton)
